import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './timeline-zoom-options.module.scss';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {TIMELINE_MAX_WIDTH_PER_SECOND, TIMELINE_MIN_WIDTH_PER_SECOND, updateTimelineWidthPerSecond} from '@Components/poster-editor/components/timeline/timeline-reducer';
import {convertNonLinearSliderPositionToValue, convertValueToNonLinearSliderPosition, NON_LINEAR_SLIDER_MAX, NON_LINEAR_SLIDER_MIN} from '@Utils/slider.util';

export function TimelineZoomOptions(): ReactElement {
  const widthPerSecond = useAppSelector((state) => {
    return state.timeline.widthPerSecond;
  });
  const dispatch = useAppDispatch();

  const getValToDisplayVal = (val: number): number => {
    return convertValueToNonLinearSliderPosition(val, TIMELINE_MIN_WIDTH_PER_SECOND, TIMELINE_MAX_WIDTH_PER_SECOND);
  };

  const getDisplayValToVal = (displayVal: number): number => {
    return convertNonLinearSliderPositionToValue(displayVal, TIMELINE_MIN_WIDTH_PER_SECOND, TIMELINE_MAX_WIDTH_PER_SECOND);
  };

  const onSlideHandler = (newVal: number): void => {
    dispatch(updateTimelineWidthPerSecond(getDisplayValToVal(newVal)));
  };

  const getSliderForTimelineZoom = (): ReactElement => {
    return (
      <>
        <Icon icon="icon-zoom-out" className={`content-disabled ${styles.defaultMargin}`} size={IconSize.SIZE_ICON_16} />
        <ControlledSlider
          className={`${styles.defaultMargin} ${styles.slider}`}
          onSlide={onSlideHandler}
          value={getValToDisplayVal(widthPerSecond)}
          min={NON_LINEAR_SLIDER_MIN}
          max={NON_LINEAR_SLIDER_MAX}
        />
        <Icon icon="icon-zoom-in" className="content-disabled spacing-m-r-4" size={IconSize.SIZE_ICON_16} />
      </>
    );
  };

  const onMinimize = (): void => {
    window.posterEditor?.whiteboard?.updateIsTimelineMode(false);
  };

  return (
    <div className="flex-h-row flex-items-center">
      {getSliderForTimelineZoom()}
      <Icon onClick={onMinimize} icon="icon-collapse" size={IconSize.SIZE_ICON_20} shape={IconShape.SQUARE} type={IconType.GHOST} />
    </div>
  );
}
